export enum ErrorTypes {
  Size = 'Size too big',
  Extension = 'file-invalid-type',
  TooMany = 'too-many-files'
}
